import React, { memo } from "react"

import {
  ChatDownIcon,
  PowerfulMessage,
  UserMessagesLayout,
} from "@shared/components"
import VirtualizedMessages from "@shared/components/chat/messages/VirtualizedMessages"
import { useMessagesContext, useSchedule } from "@shared/contexts"

interface Props {
  isActive: boolean
}

function UserMessages({ isActive }: Props) {
  const { schedule } = useSchedule()
  const { messages } = useMessagesContext()

  const scheduleId = schedule?.id

  return (
    <UserMessagesLayout
      isActive={isActive}
      overflowStyle="hidden"
      fullHeight
      inner={({ scrollMessages, messagesRef, noticeHeight }) => (
        <>
          <VirtualizedMessages
            messages={messages}
            messagesRef={messagesRef}
            noticeHeight={noticeHeight}
            renderMessage={(message, onMeasure) => (
              <PowerfulMessage
                key={message.key}
                scrollMessages={scrollMessages}
                message={message}
                isNicknameStyled
                showBlindButton
                scheduleId={scheduleId}
                onImageLoad={onMeasure}
              />
            )}
          />

          <ChatDownIcon messagesRef={messagesRef} />
        </>
      )}
    />
  )
}

export default memo(UserMessages)
